exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-credits-information[data-v-7434d413]{padding:20px 0}.no-credits-information__ttl[data-v-7434d413]{font-weight:700;font-size:16px;font-size:1.6rem;margin-bottom:10px}.no-credits-information .btn[data-v-7434d413]{margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7434d413","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/Credit.vue
// module id = 437
// module chunks = 0